module.exports = __webpack_public_path__ + "static/media/MuscularSystem_Normal.ff834dfa.jpg";